import { formatDate } from "../../../utils";

export async function generatePrintCaHtml(process) {
    return `
      <!DOCTYPE html>
      <html lang="pt-BR">
      <link rel="icon" type="image/png" href="/assets/logos/logo.png" />
      <head>
        <meta charset="UTF-8">
        <title>GOTT - Gestor de Operações de Transito e Transporte</title>
        <style>
          body {
            font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
            font-size: 14px;
            line-height: 1.42857143;
            color: #333;
            background-color: #fff;
            margin: 0;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 4px;
          }
          td {
            border: 1px solid black;
            padding: 2px;
            vertical-align: top;
            line-height: 1.42857143;
            width: 33.33333333%;
          }
          small {
            margin-top: 1px;
            display: block;
            font-size: 7pt;
            line-height: 8px;
          }
          strong {
            font-weight: bold !important;
          }
          p {
            margin: 0 !important;
          }
          h1 {
            font-weight: 500;
            line-height: 1.1;
            margin: 0.67em 0;
          }
          h4 {
            margin-top: 10px;
            margin-bottom: 10px;
            font-size: 18px;
            line-height: 1.1;
            font-weight: 500;
          }
          .text-center {
            text-align: center;
          }
          .highlighted {
            font-size: 36px;
            font-weight: 500;
            text-align: center;
            margin: 5px 0;
            text-decoration: underline;
            text-transform: uppercase;
          }
          .head-text {
            font-size: 14px;
            line-height: 1.42857143;
            color: #333;
            padding: 0 15px;
          }
          .image-container {
            padding-left: 15px;
            padding-right: 15px;
            min-height: 1px;
          }
          .align-middle {
            vertical-align: middle !important;
          }
          @media print {
            @page {
              margin: 0;
              size: auto;
            }
            body {
              margin: 0;
            }
            header, footer {
              display: none;
            }
          }
        </style>
      </head>
      <body>
        <div class="cape" style="max-width: 800px; margin: 16px">
          <div class="row" style="display: flex; justify-content: space-between; margin-bottom: 8px;">
            <div class="image-container" style="width: 25%; text-align: center; transform: translateX(-15px);">
              <img src="${process?.company_logo}" width="100%"  alt=""/>
            </div>
            <div class="head-text" style="text-align: center;">
              <strong>${process?.company_state_description}</strong><br/>
              <strong>${process?.company_owner_name}</strong><br/>
              <strong>${process?.company_name}</strong>
            </div>
            <div class="image-container" style="width: 25%; text-align: center;">
              <img src="${process?.company_owner_logo}" width="100%"  alt=""/>
            </div>
          </div>
    
          <h4 class="text-center">AUTUAÇÃO DE PROCESSO ADMINISTRATIVO DE INFRAÇÃO DE TRÂNSITO</h4>
    
          <table style="margin-left: 66.66666667%; width: calc(100% / 3)">
            <tr>
              <td class="text-center align-middle"><strong>PROC.:</strong></td> 
              <td><small>NÚMERO</small> ${process?.numero}</td>
            </tr>
          </table>
    
          <h1 class="highlighted">${process?.type}</h1>
    
          <p>1 - DADOS DO REQUERENTE</p>
          <table>
            <tr>
              <td colspan="2"><small>NOME DO PROPRIETÁRIO</small> ${process?.nome_proprietario_veiculo ? process?.nome_proprietario_veiculo : ''}</td>
              <td><small>CPF/CNPJ PROPRIETÁRIO</small> ${process?.cpf_cnpj_proprietario_veiculo ? process?.cpf_cnpj_proprietario_veiculo : ''}</td>
            </tr>
            <tr>
              <td colspan="2"><small>NOME DO CONDUTOR</small> ${process?.nome_condutor}</td>
              <td><small>CPF/CNPJ CONDUTOR</small> ${process?.cpf_cnpj_condutor}</td>
            </tr>
            <tr>
              <td colspan="3"><small>RUA/NÚMERO/COMPLEMENTO/CEP</small> ${process?.logradouro_requerente}, ${process?.numero_requerente} ${process?.complemento_requerente ? '- ' + process?.complemento_requerente : ''} ${process?.cep_requerente ? '- CEP ' + process?.cep_requerente : ''}</td>
            </tr>
            <tr>
              <td><small>BAIRRO</small> ${process?.bairro_requerente}</td>
              <td><small>TELEFONE CONTATO</small> ${process?.telefone_contato}</td>
              <td><small>E-MAIL</small> ${process?.email_contato}</td>
            </tr>
          </table>
    
          <p>2 - DADOS DA INFRAÇÃO</p>
          <table>
            <tr>
              <td><small>PLACA DO VEÍCULO AUTUADO</small> ${process?.placa_veiculo}</td>
              <td><small>AIT</small> ${process?.numero_ait}</td>
              <td><small>CÓDIGO DA INFRAÇÃO</small> ${process?.codigo_tipo_infracao + '-' + process?.desdobramento_tipo_infracao}</td>
            </tr>
            <tr>
              <td><small>DATA DA INFRAÇÃO</small> ${process?.data_infracao}</td>
              <td><small>DATA LIMITE</small> ${process?.data_limit === '2199-12-31' ? 'INDETERMINADA' : formatDate(process?.date_limit)}</td>
              <td><small>DATA DE ENTRADA</small> ${process?.data_criacao}</td>
            </tr>
          </table>
    
          <p>3 - DADOS DO ATENDIMENTO</p>
          <table>
            <tr>
              <td><small>ATENDENTE</small> ${process?.creator_name}</td>
              <td><small>SITUAÇÃO</small> ${process?.kind}</td>
            </tr>
          </table>
    
          <div style="display: flex; gap: 8px;">
            <div style="width: 50%;">
              <table style="height: 120px; margin-bottom: 20px;">
                <tr>
                  <td class="text-center align-middle" style="width: 66.66666667%;"><strong>DISTRIBUIÇÃO</strong></td>
                  <td class="text-center align-middle"><strong>DATA</strong></td>
                </tr>
                <tr><td>&nbsp;</td><td>&nbsp;</td></tr>
                <tr><td>&nbsp;</td><td>&nbsp;</td></tr>
                <tr><td>&nbsp;</td><td>&nbsp;</td></tr>
              </table>
              <table style="min-height: 100px;">
                <tr>
                  <td>
                    <strong>OBSERVAÇÕES:</strong><br/>
                    ${process?.observacoes || ''}
                  </td>
                </tr>
              </table>
            </div>
    
            <div style="width: 50%;">
              <table style="height: 240px;">
                <tr>
                  <td><strong>ANEXOS:</strong><br/>
                    ${(process?.attachments || []).map(attc => `<div>${attc.document_type_descricao}</div>`).join('')}
                  </td>
                </tr>
              </table>
            </div>
          </div>
    
          <br/>
    
          <table>
            <tr>
              <td class="text-center" style="width: 33.33333333%"><img src="${process?.company_logo}" width="180px"  alt=""/></td>
              <td colspan="2">
                <div style="display: flex; flex-direction: column; justify-content: space-between;">
                  <div style="display: flex; justify-content: space-between;">
                        <strong>${process?.company_state_description}</strong>
                        <strong>${process?.numero_ait}</strong>
                    </div>
                    <strong>${process?.company_owner_name}</strong>
                    <strong>${process?.company_name}</strong>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="3" class="text-center">
                <strong>PROTOCOLO DE ENTREGA DE DOCUMENTOS PARA RECURSOS DE INFRAÇÕES DE TRÂNSITO - ${process?.department_sigla}</strong>
              </td>
            </tr>
            <tr>
              <td><small>PROCESSO</small> ${process?.numero}</td>
              <td colspan="2"><small>PROPRIETÁRIO</small> ${process?.nome_proprietario_veiculo}</td>
            </tr>
            <tr>
              <td><small>PLACA DO VEÍCULO</small> ${process?.placa_veiculo}</td>
              <td colspan="2"><small>CONDUTOR</small> ${process?.nome_condutor}</td>
            </tr>
            <tr>
              <td><small>DATA DO PROTOCOLO</small>${process?.data_criacao}</td>
              <td><small>DATA LIMITE</small>${process?.data_limit === '2199-12-31' ? 'INDETERMINADA' : formatDate(process?.date_limit)}</td>
              <td><small>DATA DA INFRAÇÃO</small>${process?.data_infracao}</td>
            </tr>
          </table>
        </div>
      </body>
      </html>
  `;
}
